// Depth-first flatten (document order) — used for prev/next focus targets
export const flattenBlocks = (blocks) =>
  blocks.flatMap((block) => [block, ...(block.children?.length ? flattenBlocks(block.children) : [])]);

/**
 * Document-order list of blocks that can receive caret via arrow navigation.
 * Toggle titles are included; descendants of collapsed toggles are skipped
 * (they are unmounted from the DOM while the toggle is closed).
 */
export const flattenNavigableBlocks = (blocks, navigableTypes, { underCollapsed = false } = {}) => {
  const result = [];
  for (const block of blocks || []) {
    const collapsed = block.type === 'toggle' && block.props?.isOpen === false;
    if (!underCollapsed && navigableTypes.includes(block.type)) {
      result.push(block);
    }
    if (block.children?.length) {
      let kids = block.children;
      if (block.type === 'choice' && !block.props?.showAll) {
        const active = block.props?.activePathId;
        kids = kids.filter((child, i) =>
          child.type !== 'choice-path' || child.id === active || (!active && i === 0)
        );
      }
      result.push(
        ...flattenNavigableBlocks(kids, navigableTypes, {
          underCollapsed: underCollapsed || collapsed,
        })
      );
    }
  }
  return result;
};
